export const setDropdown = (dropdownIndex) => {
    return {
      type: 'TOGGLE_DROPDOWN',
      payload: dropdownIndex,
    };
  };
  
  export const setMdDropdown = (dropdownIndex) => {
    return {
      type: 'TOGGLE_MD_DROPDOWN',
      payload: dropdownIndex,
    };
  };
  
  